<template>
  <div class="infinite-list">
    <template v-for="(item, index) in items">
      <slot :item="item" :index="index"> </slot>
    </template>

    <div class="infinite-scroll">
      <!-- <template v-if="off">
        <p class="infinite-activator">-</p>
      </template> -->

      <template v-if="!off">
        <div
          v-intersect.quiet="{ handler: infiniteScrolling, options: { threshold: [1.0] } }"
          @click="clickIntersect()"
        >
          <slot name="activator">
            <p class="infinite-activator">
              <LoadingText :loading="loading"> 더보기 </LoadingText>
            </p>
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import LoadingText from '@/components/common/text/LoadingText.vue'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    off: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingText,
  },
  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (this.off) {
        return
      }

      if (isIntersecting === true) {
        this.$emit('intersect')
      }
    },
    clickIntersect() {
      if (this.off) {
        return
      }

      this.$emit('intersect')
    },
  },
}
</script>

<style lang="scss" scoped>
.infinite {
  &-activator {
    background-color: rgb(174, 174, 174, 0.2);
    color: $black;
    text-align: center;

    margin: 0;
    padding: 15px 0;
  }
}
</style>
